const _excluded = ["alt", "size", "backgroundColor", "color", "icon", "imageUrl", "shadow", "loading"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { Spinner } from "../Spinner";
import { cx } from "../../helpers/utils/cx";
const sizes = {
  "2xs": "w-5 h-5",
  xs: "w-7 h-7",
  sm: "w-9 h-9",
  md: "w-12 h-12",
  lg: "w-14 h-14",
  xl: "w-20 h-20"
};
const contentSizes = {
  "2xs": "w-3 h-3",
  xs: "w-5 h-5",
  sm: "w-5 h-5",
  md: "w-6 h-6",
  lg: "w-6 h-6",
  xl: "w-10 h-10"
};
function ContentWrapper(_ref) {
  let {
    sizeClasses,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(sizeClasses, "flex items-center justify-center")
  }, children);
}
function IconView(_ref2, ref) {
  let {
      alt,
      size = "md",
      backgroundColor = "bg-neutral-secondary",
      color,
      icon,
      imageUrl,
      shadow,
      loading = false
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  // for images shadow should be on by default
  const hasShadow = shadow === undefined && imageUrl ? true : shadow;
  const contentColorClass = color || (imageUrl ? "text-static-key-light" : "text-primary");
  let content = null;
  if (loading) {
    content = /*#__PURE__*/React.createElement(ContentWrapper, {
      sizeClasses: contentSizes[size]
    }, /*#__PURE__*/React.createElement(Spinner, {
      color: contentColorClass,
      size: "inherit"
    }));
  } else if (icon && !imageUrl) {
    content = /*#__PURE__*/React.createElement(ContentWrapper, {
      sizeClasses: contentSizes[size]
    }, /*#__PURE__*/React.cloneElement(icon, {
      className: cx(contentColorClass),
      width: "100%",
      height: "100%",
      role: "img",
      "aria-label": alt
    }));
  }
  const containerClasses = cx(sizes[size], "border-0 rounded-full", "bg-cover", "flex items-center justify-center", hasShadow && "shadow-[inset_0_0_8px_rgba(26,27,35,0.08)]", imageUrl && loading && "brightness-90", backgroundColor);
  const containerStyles = imageUrl ? {
    backgroundImage: `url(${imageUrl})`
  } : {};
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: containerClasses,
    style: containerStyles,
    title: alt
  }, rest), content);
}
const ForwardedIconView = /*#__PURE__*/React.forwardRef(IconView);
export { ForwardedIconView as IconView };